export const RequestTranslations = {
    entityName: 'Richiesta',
    fields: {
        uid: 'UID',
        ipAddress: 'Indirizzo IP',
        createdAt: 'Data richiesta',
    }

}
import {QuerySortOperatorEnum} from "@overflo1/frame-frontend";

export const RequestFullTableConfig = {
    ignoreGeneratedColumns: false,
    defaultSort: {field: 'createdAt', order: QuerySortOperatorEnum.desc},
    allowedColumns: [
        'uid',
        'ipAddress',
        'createdAt',
    ],
    columns: []
}

export const RequestDynamicFormConfig = {
    ignoreGeneratedForms: false,
    forms: [],
    readonly: true,
}
